export default __webpack_public_path__ + "static/dt-blue-background-d04791a010c513c4f8d892ffc7f9b230.png";